const customStylesForBreed = {
  option: () => ({ marginBottom: 10 }),

  menuList: () => ({
    position: 'absolute',
    width: 300,
    color: '#8C8C8C',
    backgroundColor: '#FFFFFF',
    marginTop: 30,

    borderRadius: '30px',
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 10,
    fontSize: 16,
    fontFamily: 'Jost',
    fontWeight: 400,
    lineHeight: 1.5,
    overflow: 'hidden',
    zIndex: 1000,
  }),

  placeholder: provided => ({
    ...provided,
    color: '#1D1D1D',
  }),

  menu: () => ({
    height: 0,
    marginTop: 0,
  }),

  control: () => ({
    marginLeft: 10,
    width: 226,
    height: 40,
    backgroundColor: '#F8F8F7',
    borderRadius: 10,
    fontSize: 16,
    fontFamily: 'Jost',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#1D1D1D',
  }),

  clearIndicator: () => ({ display: 'none' }),

  dropdownIndicator: () => ({
    position: 'absolut',
    marginLeft: 195,
    marginTop: -55,
    color: '#8C8C8C',
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
};

const customStylesForBreedLong = {
  option: (provided, state, styles) => ({ marginBottom: 10 }),

  menuList: () => ({
    position: 'absolute',
    width: 300,
    height: 800,
    color: '#8C8C8C',
    backgroundColor: '#FFFFFF',
    marginTop: 30,
    borderRadius: '30px',
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 10,
    fontSize: 16,
    fontFamily: 'Jost',
    fontWeight: 400,
    lineHeight: 1.5,
    zIndex: 1000,
    overflow: 'scroll',
  }),

  menu: () => ({
    height: 0,
    marginTop: 0,
  }),

  control: () => ({
    marginLeft: 10,
    width: 226,
    height: 40,
    backgroundColor: '#F8F8F7',
    borderRadius: 10,
    fontSize: 16,
    fontFamily: 'Jost',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#1D1D1D',
  }),

  clearIndicator: () => ({ display: 'none' }),

  dropdownIndicator: () => ({
    position: 'absolut',
    marginLeft: 195,
    marginTop: -55,
    color: '#8C8C8C',
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
};

export { customStylesForBreed, customStylesForBreedLong };
